export default "__VITE_ASSET__D7YlCWaY__"